import {requestJson} from '@/ui/services/api.ts';
import {
  CharacterCustomizationConfig,
  CharacterCustomizationConfigSchema,
  CharacterPatchRequestDTO,
  CharacterPatchResponseDTO,
  CharacterPatchResponseSchema,
  CharacterCreationConfigDTO,
  CharacterCreationConfigSchema
} from '@hexcrawl/shared-utils';

export const characterService = {
  config(): Promise<CharacterCreationConfigDTO> {
    return requestJson<CharacterCreationConfigDTO>({
      url: '/character/config',
      method: 'GET',
      schema: CharacterCreationConfigSchema
    });
  },

  create(): Promise<CharacterPatchResponseDTO> {
    return requestJson<CharacterPatchResponseDTO>({
      url: '/character/new',
      method: 'POST',
      data: {},
      schema: CharacterPatchResponseSchema,
    });
  },

  update(payload: CharacterPatchRequestDTO): Promise<CharacterPatchResponseDTO> {
    return requestJson<CharacterPatchResponseDTO>({
      url: '/character/update',
      method: 'PATCH',
      data: payload,
      schema: CharacterPatchResponseSchema,
    });
  },

  customizationConfig(): Promise<CharacterCustomizationConfig> {
    return requestJson<CharacterCustomizationConfig>({
      url: '/character/customization-config',
      method: 'GET',
      schema: CharacterCustomizationConfigSchema,
    });
  },
};
